module.exports = __webpack_public_path__ + "static/mikulaskova-264ab348f70d99ba3ee80ef95e807db0.jpg";